<mat-card class="flex flex-col h-full gap-4 px-2 pt-1" style="overflow-y: scroll;">
    <div *ngFor="let image of _attachmentList">
        <img [src]="image.attachFilePic" (click)="myFunction(image)" [style]="getStyle(image.isSelected)" />
        <h4 [style]="getNameStyle(image.isEdit)">{{image.attachTypeName}}</h4>
        <h4 *ngIf="image.remark != undefined && image.remark != null && image.remark != ''"><a class="remark" (click)="openRemark(image)">หมายเหตุ</a></h4>
    </div>
</mat-card>